import React, {useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import MaterialTable from "material-table";
import {tableIcons} from "../../shared/MaterialTableIcons";
import {ROUTES} from "../../utils/RouteConstants";
import {deleteDependant} from "../../api/RestCallHelper";
import {ROLES} from "../../api/Constants";
import DependantTableDetailPanel from "./dependants-table-details-panel/DependantTableDetailPanel";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import useUserData from "../../hooks/useUserData";

export default function DependantsTable({
  last,
  tableData,
  tableHeaders,
  member,
  showDropDown
}) {

  const user = useUserData();

  let history = useHistory();
  let location = useLocation();

  let dispatch = useFeedbackDispatch();

  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const [headers] = useState(tableHeaders);
  const [data, setData] = useState(tableData);

  const close = (event, reason) => {
    console.log("In useFetchRelationshipTypes close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
  };

  return (
    <>
      {user && (

        <div>
        {/* {console.log(data)} */}

          <MaterialTable
            title="Dependants"
            icons={tableIcons}
            columns={headers.columns}
            data={data}
            actions={ user.role.id <= ROLES.ADMIN && [
              {
                icon: tableIcons.Edit,
                tooltip: "Edit Dependant",
                onClick: (event, rowData) => {

                  console.log("rowData", rowData);
                  history.push(ROUTES.DEPENDANTS_FORM, { last : last, dependant: {...rowData }, edit: true, member: member ? {...member}  : rowData.member })

                }

              },
            ]}
            editable={
              user.role.id <= ROLES.ADMIN && {
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    // don't send again while we are sending
                    if (isSending) return;

                    // update state
                    setIsSending(true);

                    // send the actual request
                    deleteThisRow(oldData);
                    async function deleteThisRow(data){
                      const success = await deleteDependant(data.id, dispatch, close, history, location);
                      // debugger
                      if(success === true) resolve();
                      else reject();
                    }
                  }).then(() => {
                      // once the request is sent, update state again
                      if (isMounted.current)
                        // only update if we are still mounted
                        setIsSending(false);

                      // setTimeout(() =>{
                      const dataDelete = [...data];
                      const index = oldData.tableData.id;
                      dataDelete.splice(index, 1);
                      setData([...dataDelete]);
                      //
                      // }, 1000)
                  }).catch((error) => {
                      //console.log(error.data);
                  })
            }}
            options={{
              headerStyle: {
                backgroundColor: "var(--c1)",
                color: "#FFF",
              },
              actionsColumnIndex: -1
            }}
            detailPanel={[
              {
                tooltip: "Show Details",
                render: (rowData) => showDropDown && <DependantTableDetailPanel dependantDetails={rowData} />
              },
            ]}
          />
        </div>
      )}
    </>

  )
}

